import { useEffect, useState } from "react";
import { onAuthStateChanged } from "firebase/auth";
import { collection, query, where, onSnapshot } from "firebase/firestore";
import { firestore, auth } from "../../firebaseConfig";

/**
 * Live list of open tasks in `worldId`.
 * scope: "mine" (assigned to me) | "byMe" (assigned by me) | "team" (all).
 */
export function useOpenTasks(worldId, scope = "mine") {
  const [uid, setUid] = useState(auth.currentUser?.uid || null);
  const [tasks, setTasks] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => onAuthStateChanged(auth, u => setUid(u?.uid || null)), []);

  useEffect(() => {
    if (!worldId || !uid) { setTasks([]); setLoading(false); return undefined; }
    setLoading(true);
    const col = collection(firestore, `World/${worldId}/tasks`);
    const open = where("status", "==", "open");
    const q = scope === "team"
      ? query(col, open)
      : scope === "byMe"
        ? query(col, where("assignedByUid", "==", uid), open)
        : query(col, where("assigneeUids", "array-contains", uid), open);
    return onSnapshot(
      q,
      snap => { setTasks(snap.docs.map(d => ({ id: d.id, ...d.data() }))); setLoading(false); },
      err => { console.error("Error loading tasks:", err); setTasks([]); setLoading(false); },
    );
  }, [worldId, uid, scope]);

  return { tasks, loading };
}

/** Open tasks assigned to the signed-in user. */
export default function useMyOpenTasks(worldId) {
  return useOpenTasks(worldId, "mine").tasks;
}
